<template>
  <div id="main-content">
    <div class="wrapper">
      <jm-crumbs/>
      <div class="table-agile-info">
        <!-- <div class="common-new-title mode2">
          <span>资源合并</span>
        </div> -->

        <el-form
          ref="formData"
          :model="formData"
          :rules="rules"
          :inline="true"
          label-width="120px"
          class="mergeBox">
          <el-form-item label="被合并资源ID" prop="from_id">
            <el-input v-model.trim="formData.from_id" ref="from_id" class="jm-input110" />
          </el-form-item>
          <el-form-item label="合并到资源ID" prop="to_id">
            <el-input v-model.trim="formData.to_id" ref="to_id" class="jm-input110" />
          </el-form-item>
          <el-form-item>
            <label>&nbsp; &nbsp; &nbsp;</label>
            <el-button type="danger" @click="submitForm('formData')">合并资源</el-button>
          </el-form-item>
        </el-form>

        <el-form
          :inline="true"
          :model="searchData"
          label-width="140px"
          class="searchList">
          <el-form-item label="被合并资源ID：">
            <el-input
              v-model.trim="searchData.from_id"
              class="jm-input175"/>
          </el-form-item>
          <el-form-item label="合并到资源ID：" >
            <el-input
              v-model.trim="searchData.to_id"
              class="jm-input175"/>
          </el-form-item>
          <el-form-item label="合并时间：">
            <el-date-picker
              :editable="false"
              v-model="searchData.creationDate"
              type="daterange"
              unlink-panels
              placeholder="选择日期"
              class="jm-input280"/>
          </el-form-item>
          <el-form-item label="渠道来源：" >
            <jm-channel
              v-model="searchData.channel"
              clearable
              filterable/>
          </el-form-item>
          <div class="searchBottom">
            <el-button
              class="jm-input-common3"
              type="primary"
              @click="() => this.refresh = true">搜索</el-button>
            <el-button
              class="jm-input-common3"
              type="default"
              @click="resetFields">重置</el-button>
            <el-button
              class="jm-input-common3"
              v-if="!$hasPermission([89]) || $hasPermission([1])"
              type="success"
              :loading="exporting"
              @click="exportMerge">导出数据</el-button>
          </div>
        </el-form>

        <jm-tableList
          url="/index/system/merge"
          :search-data="searchData"
          :refresh.sync="refresh">
          <el-table-column
            slot="title"
            label="名称">
            <template slot-scope="scope">
              <router-link :to="{ name: 'menu', params: { pid: scope.row.id } }">{{ scope.row.title }}</router-link>
            </template>
          </el-table-column>
          <el-table-column
            slot="from_id"
            label="被合并到资源ID">
            <template slot-scope="scope">
              <router-link
                target="_blank"
                :to="{ name: 'editStudent', params: { id: scope.row.from_id } }">
                {{ scope.row.from_id }}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column
            slot="to_id"
            label="合并到资源ID">
            <template slot-scope="scope">
              <router-link
                target="_blank"
                :to="{ name: 'editStudent', params: { id: scope.row.to_id } }">
                {{ scope.row.to_id }}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column
            slot="userTo_text"
            label="合并到资源渠道">
            <template slot-scope="scope">
              {{ scope.row.user_to ? scope.row.user_to.custom_from : '' }}
            </template>
          </el-table-column>
          <el-table-column
            slot="lastColumn"
            label="操作"
            width="140"
            v-if="$hasPermission(1)">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="danger"
                @click="handleDelete(scope)">删除</el-button>
            </template>
          </el-table-column>
        </jm-tableList>
      </div>
    </div>
  </div>
</template>

<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import { jmChannel } from '@/components/tool';

export default {
  data() {
    return {
      exporting: false,
      refresh: false,
      searchData: {
        from_id: '',
        to_id: '',
        creationDate: [],
        channel: {}
      },
      formData: {
        from_id: '',
        to_id: '',
      },
      rules: {
        from_id: [
          { required: true, message: '请输入被合并资源ID', trigger: 'blur' },
        ],
        to_id: [
          { required: true, message: '请输入合并到资源ID', trigger: 'blur' },
        ]
      }
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
    jmChannel,
  },
  computed: {
  },
  methods: {
    resetFields() {
      Object.keys(this.searchData).forEach((k) => {
        this.searchData[k] = '';
      });
      this.searchData.creationDate = [];
      this.$store.commit('updateRefresh', true);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm('确认合并资源, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            this.$http._post({
              url: '/index/system/mergeAdd',
              data: this.formData,
            }).then((res) => {
              if (res.result === 0) {
                this.$message.success('资源合并成功!');
                this.refresh = true;
              }
            });
          }).catch(() => {
            this.$message.info('已取消合并');
          });
        } else {
          this.$message.error('请按提示补全表单！');
          return false;
        }
      });
    },
    handleDelete(scope) { // 删除
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http._post({
          url: '/index/system/mergeDel',
          data: { id: scope.row.id },
        }).then((res) => {
          if (res.result === 0) {
            this.$message.success('删除成功!');
            this.refresh = true;
          }
        });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    exportMerge() {
      this.exporting = true;
      this.$http._post({
        url: '/index/system/exportMerge',
        data: { searchData: this.searchData },
      }).then(({ data }) => {
        this.exporting = false;
        this.$http._download({
          filename: data,
          download: '合并记录.xlsx'
        });
      }).catch((data) => {
        if (typeof data.data !== 'undefined' && data.data.result === -1) {
          this.$message.error(data.data.data);
        } else {
          this.$message.error('服务异常');
        }

        this.exporting = false;
      });
    },
  },
};
</script>
<style scoped>
.mergeBox{
  background-color:#f5f5f5;padding-top:20px;margin-bottom:15px
}
</style>
